// extracted by mini-css-extract-plugin
export default {"xxlMin":"1440px","xlMax":"1439px","xlMin":"1200px","lgMax":"1199px","lgMin":"992px","mdMax":"991px","mdMin":"768px","smMax":"767px","smMin":"576px","xsMax":"575px","xsMin":"0px"};